const MODULE_NAME = "oncall/";

export const ENGINEERS_PAGE_LOAD = `@@${MODULE_NAME}ENGINEERS_PAGE_LOAD`;
export const ENGINEERS_LOADED = `@@${MODULE_NAME}ENGINEERS_LOADED`;

export const ENGINEER_PAGE_LOAD = `@@${MODULE_NAME}ENGINEER_PAGE_LOAD`;
export const ENGINEER_PAGE_LOADED = `@@${MODULE_NAME}ENGINEER_PAGE_LOADED`;
export const ENGINEER_ADD_REQUEST = `@@${MODULE_NAME}ENGINEER_ADD_REQUEST`;
export const ENGINEER_UPDATE_REQUEST = `@@${MODULE_NAME}ENGINEER_UPDATE_REQUEST`;
export const ENGINEER_EMAIL_ADD_REQUEST = `@@${MODULE_NAME}ENGINEER_EMAIL_ADD_REQUEST`;
export const ENGINEER_EMAIL_DELETE_REQUEST = `@@${MODULE_NAME}ENGINEER_EMAIL_DELETE_REQUEST`;
export const ENGINEER_UPDATED = `@@${MODULE_NAME}ENGINEER_UPDATED`;
export const ENGINEER_EMAIL_ADDED = `@@${MODULE_NAME}ENGINEER_EMAIL_ADDED`;
export const ENGINEER_EMAIL_DELETED = `@@${MODULE_NAME}ENGINEER_EMAIL_DELETED`;
export const ENGINEER_ADD_ERROR = `@@${MODULE_NAME}ENGINEER_ADD_ERROR`;
export const ENGINEER_UPDATE_ERROR = `@@${MODULE_NAME}ENGINEER_UPDATE_ERROR`;
export const ENGINEER_EMAIL_ADD_ERROR = `@@${MODULE_NAME}ENGINEER_EMAIL_ADD_ERROR`;
export const ENGINEER_EMAIL_DELETE_ERROR = `@@${MODULE_NAME}ENGINEER_EMAIL_DELETE_ERROR`;

export const ENGINEER_SEARCH_PAGE_LOAD = `@@${MODULE_NAME}ENGINEER_SEARCH_PAGE_LOAD`;
export const ENGINEER_SEARCH_NEEDLE_CHANGED = `@@${MODULE_NAME}ENGINEER_SEARCH_NEEDLE_CHANGED`;
export const ENGINEER_SEARCH_RESULTS_LOADED = `@@${MODULE_NAME}ENGINEER_SEARCH_RESULTS_LOADED`;

//add email for engineer
export const ON_ENGINEER_EMAIL_ADD = `@@${MODULE_NAME}ON_ENGINEER_EMAIL_ADD`;

// Creators for engineers list
export const engineersPageLoad = () => ({
  type: ENGINEERS_PAGE_LOAD,
  payload: {},
});

export const engineersLoaded = engineers => ({
  type: ENGINEERS_LOADED,
  payload: {
    engineers,
  },
});

export const engineerPageLoad = engineerId => ({
  type: ENGINEER_PAGE_LOAD,
  payload: {
    engineerId,
  },
});

export const engineerPageLoaded = engineer => ({
  type: ENGINEER_PAGE_LOADED,
  payload: {
    engineer,
  },
});

export const engineerAddRequest = formData => ({
  type: ENGINEER_ADD_REQUEST,
  payload: {
    formData,
  },
});

export const engineerUpdateRequest = (engineerId, formData) => ({
  type: ENGINEER_UPDATE_REQUEST,
  payload: {
    engineerId,
    formData,
  },
});

export const engineerEmailAddRequest = (engineerId, email) => ({
  type: ENGINEER_EMAIL_ADD_REQUEST,
  payload: {
    engineerId,
    email,
  },
});

export const engineerEmailDeleteRequest = (engineerId, email) => ({
  type: ENGINEER_EMAIL_DELETE_REQUEST,
  payload: {
    engineerId,
    email,
  },
});

export const engineerUpdated = () => ({
  type: ENGINEER_UPDATED,
  payload: {},
});

export const engineerEmailAdded = email => ({
  type: ENGINEER_EMAIL_ADDED,
  payload: {
    email,
  },
});

export const engineerEmailDeleted = email => ({
  type: ENGINEER_EMAIL_DELETED,
  payload: {
    email,
  },
});

export const engineerAddError = message => ({
  type: ENGINEER_ADD_ERROR,
  payload: {
    message,
  },
});

export const engineerUpdateError = message => ({
  type: ENGINEER_UPDATE_ERROR,
  payload: {
    message,
  },
});

export const engineerEmailAddError = message => ({
  type: ENGINEER_EMAIL_ADD_ERROR,
  payload: {
    message,
  },
});

export const engineerEmailDeleteError = email => ({
  type: ENGINEER_EMAIL_DELETE_ERROR,
  payload: {
    email,
  },
});

export const engineerSearchPageLoad = () => ({
  type: ENGINEER_SEARCH_PAGE_LOAD,
  payload: {},
});

export const engineerSearchNeedleChanged = cityId => ({
  type: ENGINEER_SEARCH_NEEDLE_CHANGED,
  payload: {
    cityId,
  },
});

export const engineerSearchResultsLoaded = engineers => ({
  type: ENGINEER_SEARCH_RESULTS_LOADED,
  payload: {
    engineers,
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/engineers.js